/**
 * Component to attend OAuth callbacks on /oauthCallback
 * @exports OAuthCallback
 */
export default function OAuthCallback() {
  return null;
}
